import { partNumberStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPartNumber";
import { css } from "styled-components";

Object.assign(partNumberStyles, {
    labelText: {
        size: 14,
        weight: "bold",
        css: css`
            margin-right: 5px;
            @media (max-width: 1199px) and (min-width: 992px) {
                display: block;
            }
        `,
    },
    valueText: {
        size: 14,
        css: css`
            margin-bottom: 5px;
        `,
    },
});
